import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=371ecf88&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=371ecf88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ecf88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371ecf88')) {
      api.createRecord('371ecf88', component.options)
    } else {
      api.reload('371ecf88', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=371ecf88&scoped=true&", function () {
      api.rerender('371ecf88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/roles/edit.vue"
export default component.exports